import { render, staticRenderFns } from "./ModalInfoCliente.vue?vue&type=template&id=fa988ac4&"
import script from "./ModalInfoCliente.vue?vue&type=script&lang=js&"
export * from "./ModalInfoCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports